<template>
  <div>
    <div class="fixed-rgpd-container">
      <div v-if="showBalloon" class="balloon-container" @click="toggleBalloon">
        <div class="balloon-message">{{ $t('messages.privacy_clickHere') }}</div>
      </div>
    </div>

    <v-btn 
      v-if="showPolicy"
      color="primary" 
      @click="closePolicy" 
      class="back-to-home-btn"
      prepend-icon="mdi-arrow-left"
    >
      {{ $t('messages.back') }}
    </v-btn>

    <div v-if="showPolicy" class="policy-content">
      <v-container>
        <v-row justify="center">
          <v-col cols="12" md="10" lg="8">
            <div class="pa-6">
              <h1 style="font: 300 32px/36px 'Roboto', sans-serif;">{{ $t('privacy.title') }}</h1>
              <p v-html="$t('privacy.content.intro')"></p>
              <h2>{{ $t('privacy.content.section1') }}</h2>
              <br>
              <h3>{{ $t('privacy.content.section1_1') }}</h3>
              <div style="padding: 5px" v-html="$t('privacy.content.section1_1_content')"></div>
              <h3>{{ $t('privacy.content.section1_2') }}</h3>
              <div style="padding: 5px" v-html="$t('privacy.content.section1_2_content')"></div>
              <br>
              <h2>{{ $t('privacy.content.section2') }}</h2>
              <br>
              <h3>{{ $t('privacy.content.section2_1') }}</h3>
              <div style="padding: 5px" v-html="$t('privacy.content.section2_1_content')"></div>
              <h3>{{ $t('privacy.content.section2_2') }}</h3>
              <p>{{ $t('privacy.content.section2_2_content') }}</p>
              <br>
              <h2>{{ $t('privacy.content.section3') }}</h2>
              <p>{{ $t('privacy.content.section3_content') }}</p>
              <br/>
              <h3>{{ $t('privacy.content.email_storage_title') }}</h3>
              <p>{{ $t('privacy.content.email_storage_content') }}</p>
              
              <v-btn 
                v-if="hasRememberedEmail"
                color="error" 
                variant="elevated"
                @click="forgetEmail"
                prepend-icon="mdi-email-remove"
                class="my-3"
              >
                {{ $t('privacy.content.forget_email_button') }}
              </v-btn>
              <br/>
              <h3>{{ $t('privacy.content.google_oauth_title') }}</h3>
              <div style="padding: 5px" v-html="$t('privacy.content.google_oauth_content')"></div>
              <br/>
              <h3>{{ $t('privacy.content.section3_1') }}</h3>
              <p>{{ $t('privacy.content.section3_1_content') }}</p>
              
              <v-btn 
                v-if="hasLanguageCookie"
                color="warning" 
                variant="elevated"
                @click="clearLanguageCookie"
                prepend-icon="mdi-translate-off"
                class="my-3"
              >
                {{ $t('messages.clear_language_cookie') }}
              </v-btn>
              <br>
              <h2>{{ $t('privacy.content.section4') }}</h2>
              <p>{{ $t('privacy.content.section4_content') }}</p>
              <br>
              <h2>{{ $t('privacy.content.section5') }}</h2>
              <p>{{ $t('privacy.content.section5_content') }}</p>
              <br>
              <h2>{{ $t('privacy.content.section6') }}</h2>
              <p>{{ $t('privacy.content.section6_content') }}</p>
              <br>
              <h2>{{ $t('privacy.content.section7') }}</h2>
              <p v-html="$t('privacy.content.section7_content')"></p>
              <br>
              <p style="text-align: center" v-html="$t('privacy.content.footer')"></p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>

export default {
  inject: ['bus'],
  data: () => ({
    showBalloon: true,
    showPolicy: false,
    items: [],
  }),
  computed: {
    hasLanguageCookie() {
      return document.cookie.includes('smartsurf_language=')
    },
    hasRememberedEmail() {
      return localStorage.getItem('rememberedEmail') !== null
    }
  },
  mounted () {
    // Show policy if accessed via direct route
    if (this.$route.name === 'Privacy Policy') {
      this.showPolicy = true
    }
    this.bus.on('privacyPolicyDialog', () => { this.openPolicy() })
    document.addEventListener('keydown', this.handleKeydown)
  },
  beforeUnmount () {
    document.removeEventListener('keydown', this.handleKeydown)
  },
  methods: {
    toggleBalloon() {
      this.showBalloon = !this.showBalloon
      this.openPolicy()
    },
    openPolicy() {
      this.showPolicy = true
      this.bus.emit('showPrivacyPolicy', true)
    },
    closePolicy() {
      this.showPolicy = false
      this.bus.emit('showPrivacyPolicy', false)
      this.$router.push('/')
    },
    handleKeydown(event) {
      if (event.key === 'Escape' && this.showPolicy) {
        this.closePolicy()
      }
    },
    clearLanguageCookie() {
      document.cookie = 'smartsurf_language=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
      this.$i18n.locale = 'pt'
      this.bus.emit('modernSnackBarMsg', { msg: this.$t('messages.language_cookie_cleared') })
    },
    forgetEmail() {
      localStorage.removeItem('rememberedEmail')
      this.bus.emit('modernSnackBarMsg', { msg: 'Remembered email has been cleared from your browser' })
    },
  },
}
</script>

<style>
.balloon-container {
  max-width: 300px;
  text-align: center;
  position: fixed;
  bottom: 20px;
  right: 20px;
  background: linear-gradient(135deg, #1976d2, #42a5f5);
  color: white;
  border-radius: 25px;
  padding: 15px 25px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.3);
  cursor: pointer;
  transition: all 0.3s ease;
  animation: slideUp 1s ease-out;
  z-index: 1001;
}
.balloon-container:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 25px rgba(0,0,0,0.4);
}
.balloon-message {
  font-size: 14px;
  font-weight: 500;
  margin: 0;
}

@keyframes slideUp {
  from {
    transform: translateY(100px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.policy-content {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
  z-index: 2000;
  overflow-y: auto;
}

.back-to-home-btn {
  position: fixed !important;
  top: 20px !important;
  right: 20px !important;
  z-index: 2001 !important;
}
</style>